// 介錯の榴弾の弧 (2026-11-04)。配布版の既定 = low (11-04 作者 p_offscreen=low)。前の弧は開発版の `?mortarArc=old`・頂点で止まる案は `hang`。
//   見えない監査 (11-04) の「画面の外から降る赤い弾に予告が無い」を等速で測った結果 (docs/research/2026-11-04-blind-audit-offscreen-overlap.md):
//   配布版の上りの弧は頂点 (y=40) より上へ膨らみ、y≈−27 まで上がる = 寄せを等倍まで引いても絵の外。
//   撃って約 0.47〜0.65 秒の 167〜184ms、弾が画面の上の縁から消え、3つに割れた所が見えないまま 933ms 前に上の縁から3発で戻ってくる。
//   low・hang とも着弾の時刻・位置・当たりを変えない (弾の絵の通り道だけ)。
//     low  = 上りは頂点まで減速して昇り (頂点より上へ出ない)、頂点で割れて3発が自由落下。割れる所が画面の中で見える。
//     hang = low に加え、頂点で一瞬止まってから割れる (上りを速めて、止まる間を作る)。
export type MortarArcMode = 'now' | 'low' | 'hang'
let mode: MortarArcMode = 'low'
/** DEV の切り替え (game.ts)。old = 前の弧 (now)・hang・指定なし = low。 */
export function setMortarArc(v: string | null): MortarArcMode { mode = v === 'old' ? 'now' : v === 'hang' ? 'hang' : 'low'; return mode }
export function mortarArcMode(): MortarArcMode { return mode }

// hang の頂点で止まる長さと、上りに使う割合 (出発→着弾のうち)。
export const MORTAR_HANG_MS = 160
const HANG_UP_SHARE = 0.42

type Pt = { x: number; y: number }

/** 出発からの経過を「上り (割れる前)」か「下り (割れた後)」と、その中の進み 0..1 に直す。now / low は半分ずつ。 */
export function mortarArcPhase(m: MortarArcMode, elapsedMs: number, departureMs: number, telegraphMs: number): { up: boolean; q: number } {
  const span = Math.max(1, telegraphMs - departureMs)
  const p = Math.max(0, Math.min(1, (elapsedMs - departureMs) / span))
  if (m !== 'hang') return p < 0.5 ? { up: true, q: p / 0.5 } : { up: false, q: (p - 0.5) / 0.5 }
  const upEnd = HANG_UP_SHARE
  const hangEnd = Math.min(0.9, upEnd + MORTAR_HANG_MS / span)
  if (p < upEnd) return { up: true, q: p / upEnd }
  if (p < hangEnd) return { up: true, q: 1 }
  return { up: false, q: (p - hangEnd) / (1 - hangEnd) }
}

/** 比較版の弧の点。上り = 横は一定・縦は減速して頂点で止まる。下り = 頂点から横は一定・縦は自由落下 (頂点より上へ出ない)。 */
export function mortarArcPointLow(start: Pt, end: Pt, q: number, up: boolean): Pt {
  const t = Math.max(0, Math.min(1, q))
  const k = up ? 1 - (1 - t) * (1 - t) : t * t
  return { x: start.x + (end.x - start.x) * t, y: start.y + (end.y - start.y) * k }
}
